module.exports = __webpack_public_path__ + "img/zsgg-1.88a31804.png";